import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {FormViewField} from '../../domain/form-view-field';
import { MatPaginator, MatSort, MatTableDataSource } from "@angular/material";
import { Router } from "@angular/router";
import { FormView } from 'app/form-views/domain/form-view';
import { FormViewService } from 'app/form-views/services/form-view.service';
import { QueryOptions } from 'app/core/commons/query.options';
import { AuthService } from 'app/core/security/auth.service';

@Component({
    selector: 'app-form-view-list',
    templateUrl: './form-view-list.component.html',
    styleUrls: ['./form-view-list.component.scss']
})
export class FormViewListComponent implements OnInit {

    @ViewChild(MatPaginator)
    paginator: MatPaginator;
    @ViewChild(MatSort)
    sort: MatSort;
    data: FormView[];
    queryOptions: QueryOptions;
    displayedColumns = [ "id", "name", "createdBy", "createdTime", ]
    resultsLength: number = 0;
    viewsDataSource = new MatTableDataSource([]);

    constructor(private viewService: FormViewService, private router: Router,
         private authService: AuthService) {
    }

    ngOnInit() {

        this.authService.user.subscribe(user => {
            if (user.hasFx("ViewData.CREATE")) {
                this.displayedColumns.push('actions')
            }
        });

        this.queryOptions = new QueryOptions();
        this.queryOptions.size = 5;
        this.viewService.findAllActive(this.queryOptions).subscribe(data => {
            this.data = data.content;
            this.resultsLength = data.totalElements;
            this.viewsDataSource.data = data.content;
        })
        this.paginator.page.subscribe(() => {
            this.queryOptions.page = this.paginator.pageIndex;
            this.queryOptions.size = this.paginator.pageSize;
            this.getData();
        });
    }

    getData(){
        this.viewService.findAllActive(this.queryOptions).subscribe(data => {
            this.data = data.content;
            this.viewsDataSource.data = data.content;
        })
    }

    goToFill(selected: FormView){
        this.router.navigate(["home", "view", "detail", selected.id]);
    }
  

}



// WEBPACK FOOTER //
// ./src/app/form-views/components/form-view-list/form-view-list.component.ts